module.exports = __webpack_public_path__ + "img/PL10052.4c50b894.png";